import { connect } from 'react-redux';
import { SearchExternalProviderProps } from 'app/area/case/components';
import { ApplicationState } from 'app/types-store';
import * as actions from './actions';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { getCaseData, getEntityContext } from 'app/infrastructure/ui/renderer/resolvers';
import { getById } from 'app/infrastructure/store';
import { selectEntityFieldValues } from 'app/area/case/features/search-external-provider/selectors';
import { SearchExternalResultValue } from 'app/area/case/types-store';
import get from 'lodash/get';

export const withSearchExternalProvider = (component: any, uiEngineProps: ConnectedComponentProps) => {
  const stateToProps = (appState: ApplicationState): Partial<SearchExternalProviderProps> => {
    const caseState = get(appState, uiEngineProps.hostProps().statePath);
    const searchExternalProvider = caseState.searchExternalProvider;
    const caseData = getCaseData(caseState, uiEngineProps);
    const resolveContext = getEntityContext(appState, uiEngineProps);
    const entity = getById(caseData, resolveContext.path);

    const inputFields = uiEngineProps.componentDescriptor.properties && 
                        uiEngineProps.componentDescriptor.properties.dataProviderInputFields as string;

    let canSearch = false;

    if (inputFields) {
      const entityFieldValues = selectEntityFieldValues(entity);
      const requiredFields = inputFields.split(',').map(f => f.trim());
      canSearch = requiredFields.some(r => entityFieldValues.some(e => e.dataTag === r));
    }
        
    return {
      fetching: searchExternalProvider && searchExternalProvider.fetching,
      results: searchExternalProvider && searchExternalProvider.resultItems,
      error: searchExternalProvider && searchExternalProvider.error,
      canSearch
    };
  };

  const dispatchToProps = (dispatch: any, props: ConnectedComponentProps): Partial<SearchExternalProviderProps> => {
    return {
      searchExternalProvider: () => dispatch(actions.searchExternalProvider(props)),
      clearResults: () => dispatch(actions.clearResults()),
      setValuesFromResult: (result: SearchExternalResultValue[]) => dispatch(actions.setValuesFromResult(props, result))
    };
  };

  return connect<any, any, any>(stateToProps, dispatchToProps)(component);
};
